// extracted by mini-css-extract-plugin
module.exports = {"projectsList":"ProjectsList_projectsList__2JWRx","content":"ProjectsList_content__vY3A1"};